import { useEffect, useState } from 'react';

const INPUT_EVENTS = ['pointerdown', 'pointermove', 'keydown', 'wheel'] as const;

/** True once `ms` pass without pointer, key or wheel input; any input clears it. */
export function useIdle(ms: number): boolean {
  const [idle, setIdle] = useState(false);
  useEffect(() => {
    let id: ReturnType<typeof setTimeout> | undefined;
    const wake = () => {
      setIdle(false);
      clearTimeout(id);
      id = setTimeout(() => setIdle(true), ms);
    };
    for (const type of INPUT_EVENTS) window.addEventListener(type, wake, { passive: true });
    wake();
    return () => {
      clearTimeout(id);
      for (const type of INPUT_EVENTS) window.removeEventListener(type, wake);
    };
  }, [ms]);
  return idle;
}
